import { Box, Flex, Image, SimpleGrid, Text } from "@chakra-ui/react";
import { SOCIAL_PILLARS } from "./homeContent";
import { H2, Kicker, Lead, Section, alpha, useHomeTokens } from "./primitives";

/** #social — "We are all connected — so build like it". Image left, copy right; stacks on mobile. */
export const Social = () => {
  const t = useHomeTokens();
  return (
    <Section id="social" alt py={0} px={0}>
      <SimpleGrid columns={{ base: 1, lg: 2 }} alignItems="stretch">
        <Box position="relative" minH={{ base: "280px", lg: "460px" }} overflow="hidden">
          <Image
            src="/assets/hero.webp"
            alt="People connected around the planet"
            loading="lazy"
            position="absolute"
            inset={0}
            w="100%"
            h="100%"
            objectFit="cover"
            display="block"
          />
          <Box
            position="absolute"
            inset={0}
            bg={{
              base: `linear-gradient(180deg, ${alpha(t.bg, 0.25)} 0%, ${alpha(t.bg, 0.1)} 50%, ${t.bgAlt} 100%)`,
              lg: `linear-gradient(90deg, ${alpha(t.bg, 0.45)} 0%, ${alpha(t.bg, 0.1)} 40%, ${alpha(t.bgAlt, 0.95)} 100%)`,
            }}
          />
        </Box>
        <Flex
          direction="column"
          gap="20px"
          justify="center"
          maxW="660px"
          px={{ base: 6, lg: "56px" }}
          py={{ base: 12, lg: "96px" }}
        >
          <Kicker>A new social layer</Kicker>
          <H2>We are all connected — so build like it</H2>
          <Lead>
            Through our networks, friends, institutions and financial transactions, we are already a single system.
            Business Builder adds the layer that makes those connections legible: shared governance, verifiable
            reputation, and cooperation that does not require a middleman.
          </Lead>
          <Lead>
            Blockchain and decentralized systems let us build transparent, accountable businesses that enhance human
            dignity rather than suppressing it. Tools for sovereignty and cooperation, not control.
          </Lead>
          <SimpleGrid columns={{ base: 1, sm: 3 }} gap="14px" mt="14px">
            {SOCIAL_PILLARS.map((p) => (
              <Box key={p.title} pt="16px" borderTop="1px solid" borderColor={alpha(t.text, 0.12)} minW={0}>
                <Text fontSize="1.6rem" fontWeight="600" letterSpacing="-0.03em" color={t.text}>
                  {p.title}
                </Text>
                <Text fontSize=".85rem" color={t.textMuted} mt="5px">
                  {p.body}
                </Text>
              </Box>
            ))}
          </SimpleGrid>
        </Flex>
      </SimpleGrid>
    </Section>
  );
};
